// These processors save our own reference as `processorTransactionId` and keep
// their own id in the response meta, under a key that differs per processor.
// Every other processor already saves its own id as `processorTransactionId`,
// so it needs no extra row.
export interface ProcessorOwnIdMeta {
  beepTransactionID?: string | number;
  transactionId?: string;
  globalId?: string;
  papssTxId?: string;
}

export const getProcessorOwnId = (
  processor: string | undefined | null,
  responseMeta: ProcessorOwnIdMeta | undefined | null,
): string | undefined => {
  switch (processor) {
    case 'CELLULANT':
      return toId(responseMeta?.beepTransactionID);
    case 'FAIRMONEY':
      return toId(responseMeta?.transactionId);
    case 'PAYSEND':
      return toId(responseMeta?.globalId);
    case 'PAPSS':
      return toId(responseMeta?.papssTxId);
    default:
      return undefined;
  }
};

const toId = (value: string | number | undefined): string | undefined =>
  typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : undefined;
